import {
  ACHIEVEMENT_ID_TO_DATA,
  type AchievementId,
  type UserProgression,
} from '@/client/services/progression'
import { getAchievementIconUrl } from '@/client/services/url'

import BadgeDetail from './BadgeDetail'

export default function AchievementBadgeDetail({
  achievementId,
  progression,
}: {
  achievementId: AchievementId
  progression: Partial<UserProgression>
}): JSX.Element {
  const achievement = ACHIEVEMENT_ID_TO_DATA[achievementId]
  const { title, subtitle, criteriaKey, criteriaValue, iconActive, iconInactive, link } =
    achievement
  const currentCriteriaValue = progression[criteriaKey] ?? 0
  const completed = currentCriteriaValue >= criteriaValue
  return (
    <BadgeDetail
      title={title}
      subtitle={subtitle}
      iconUrl={getAchievementIconUrl(completed ? iconActive : iconInactive)}
      link={link}
      criteria={{ currentValue: currentCriteriaValue, targetValue: criteriaValue }}
    />
  )
}
